import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Music, Facebook, Youtube } from 'lucide-react';
import { getSettings } from '../lib/api';

export const Footer = () => {
  const [settings, setSettings] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await getSettings();
        setSettings(res.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-neutral-900 text-white py-12 sm:py-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              {settings?.logo_data ? (
                <img src={settings.logo_data} alt={settings?.site_name || 'DJ'} className="h-8 sm:h-10 w-auto" />
              ) : (
                <>
                  <Music className="w-6 h-6 sm:w-8 sm:h-8" />
                  <span className="text-xl sm:text-2xl font-bold" style={{ fontFamily: 'Syne, sans-serif' }}>
                    {settings?.site_name || 'DJ Services'}
                  </span>
                </>
              )}
            </div>
            <p className="text-neutral-400 text-sm sm:text-base max-w-md">
              {settings?.tagline || 'Professional DJ services for weddings, corporate events, and private parties. Making your events unforgettable with the perfect soundtrack.'}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-base sm:text-lg" style={{ fontFamily: 'Syne, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/packages" className="text-neutral-400 hover:text-white transition-colors text-sm sm:text-base">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/media" className="text-neutral-400 hover:text-white transition-colors text-sm sm:text-base">
                  Photos & Media
                </Link>
              </li>
              <li>
                <Link to="/reviews" className="text-neutral-400 hover:text-white transition-colors text-sm sm:text-base">
                  Reviews
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-neutral-400 hover:text-white transition-colors text-sm sm:text-base">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4 text-base sm:text-lg" style={{ fontFamily: 'Syne, sans-serif' }}>
              Follow Us
            </h4>
            <div className="flex gap-4">
              {settings?.facebook_url && (
                <a 
                  href={settings.facebook_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-white transition-colors" 
                  aria-label="Facebook"
                  data-testid="footer-facebook-link"
                >
                  <Facebook size={22} />
                </a>
              )}
              {settings?.youtube_url && (
                <a 
                  href={settings.youtube_url}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-neutral-400 hover:text-white transition-colors" 
                  aria-label="YouTube"
                  data-testid="footer-youtube-link"
                >
                  <Youtube size={22} />
                </a>
              )}
              {!settings?.facebook_url && !settings?.youtube_url && (
                <p className="text-neutral-500 text-sm">Social links coming soon</p>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 mt-8 sm:mt-12 pt-6 sm:pt-8 text-center text-neutral-500 text-xs sm:text-sm">
          <p>© {currentYear} {settings?.company_name || 'DJ Services LLC'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
